export default "__VITE_ASSET__gdeFDzF2__"